import Vue from 'vue'
import Vuex from 'vuex'
import {ColeccionLandingImagenes, storage} from '@/FirebaseConfig'
Vue.use(Vuex)
export default {
    namespaced:true,
    state:{
      cargando: false,
      registro: [],
    },
    actions:{
      obtener_todos:({state})=>{
        ColeccionLandingImagenes.onSnapshot(doc=>{
          if(doc.exists) state.registro = doc.data().lista
        })
      },
      agregar: ( {state}, contenido) => {
        state.registro.push(contenido)
        ColeccionLandingImagenes.set({lista: state.registro}) 
      },
      eliminar: ({state}, _nombre) => {
        storage.ref('landing_page').child(_nombre).delete().then(() => ColeccionLandingImagenes.set({lista: state.registro.filter(({nombre})=>nombre != _nombre)}) 
        ).catch( error => {
          console.log(error)
        })
      },
      publicar: ({state}, _nombre) => {
        const index = state.registro.findIndex( ({nombre}) => nombre == _nombre)
        state.registro[index].publico = !state.registro[index].publico
        ColeccionLandingImagenes.set({lista: state.registro}) 
      }
     
    },
    getters:{
      registro: state => state.registro,
      registro_publico: ({registro}) => registro.filter( ({publico}) => publico )

    }
}
